module.exports = __webpack_public_path__ + "img/join_pocket.f9e20784.svg";